import {Nullish} from 'utility-types';

import {useEffect, useState} from 'react';

import {head, isNotNil} from 'ramda';

import {thumbnailUrl as fallbackImageUrl} from '@dms/shared';

import {ThumbnailImageVehicle} from '../types/ThumbnailImageVehicle';

interface ThumbnailImageSet {
  url: string | Nullish;
  key: string;
  onError?: () => void;
}

export const useThumbnailImage = (
  vehicle: ThumbnailImageVehicle | Nullish,
  preferredImage: 'thumbnail' | 'firstFromGallery' = 'thumbnail'
): ThumbnailImageSet => {
  const [isPreferredImageLoadError, setPreferredImageLoadError] = useState(false);
  const [isAlternativeImageLoadError, setAlternativeImageLoadError] = useState(false);

  const thumbnailUrl = vehicle?.thumbnailUrl?.full;
  const firstGalleryImageUrl = isNotNil(vehicle?.pictureUrls) ? head(vehicle?.pictureUrls) : null;

  const preferredImageUrl = preferredImage === 'thumbnail' ? thumbnailUrl : firstGalleryImageUrl;
  const alternativeImageUrl = preferredImage === 'thumbnail' ? firstGalleryImageUrl : thumbnailUrl;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPreferredImageLoadError(false);
    setAlternativeImageLoadError(false);
  }, [vehicle]);

  if (!isPreferredImageLoadError && isNotNil(preferredImageUrl)) {
    return {
      url: preferredImageUrl,
      key: 'preferred',
      onError: () => setPreferredImageLoadError(true),
    };
  }

  if (!isAlternativeImageLoadError && isNotNil(alternativeImageUrl)) {
    return {
      url: alternativeImageUrl,
      key: 'alternative',
      onError: () => setAlternativeImageLoadError(true),
    };
  }

  return {url: fallbackImageUrl, key: 'fallback'};
};
